import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import pluralize from 'pluralize';
import moment from 'moment';
import Fa from 'react-fontawesome';
import {
  Button, FormGroup, ControlLabel, FormControl,
  HelpBlock, Tabs, Tab, Dropdown, MenuItem,
  Modal,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { keys, each, find, values, first, reduce, isArray, cloneDeep, startsWith } from 'lodash';
import Joi from 'joi';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';
import { fetchAllFeedbackRequestAutomations, fetchFeedbackRequestAutomation, feedbackHistoryRun } from '../../SetupActions';
import { getDiscoveryBotSettings } from '../../SetupReducer';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getFooterHeight } from '../../../App/AppReducer';
import SearchForm from '../../../../components/search-form';
import { getSearchQuery, cleanSubmitCriteria, getIsDirty, getCloseDateFilter } from '../../../../components/search-form/search-form-reducer';
import { checkDirty, countOpportunities } from '../../../../components/search-form/search-form-actions';
import DateRangeField from '../../../../components/search-form/date-range-field';
import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';
import ProgressBar from '../../../../components/progress-bar';
import OpportunityOwnerField from './OpportunityOwnerField';
import AccountOwnerField from './OpportunityAccountOwnerField';
import OpportunityStatusField from './OpportunityStatusField';
import ContactTriggerOptions from './ContactTriggerOptions';
import OpportunityTable from '../../../Analysic/components/table/opportunity-table';
import AccountTable from '../../../Dashboard/components/AccountTable';
import HistoryRunProgress from './HistoryRunProgress';
import RequestFeedbackManager from '../../../../components/request-feedback-manager';
import styles from './styles.css';
import TruVoiceDomainAuthorization from '../../../../components/tv-domain-authorizations';
import SenderList from './SenderList';
import ResellerList from './ResellerList';
const MODE_SEARCH = 'search';
const MODE_RESULTS = 'results';
const formNames = [
  'automations/discovery-bot',
  // 'automations/discovery-bot/window',
  'automations/discovery-bot/contacts/opportunity_contacts',
  'automations/discovery-bot/contacts/account_contacts',
  'automations/discovery-bot/contacts/contacts_with_activities',
  'automations/discovery-bot/contacts/custom_contact_object_references',
  'automations/discovery-bot/contacts/gong',
  'automations/discovery-bot/contacts/gong_contacts',
];

const isContactForm = (name) => {
  return startsWith(name, 'automations/discovery-bot/contacts/');
}
const contactFormType = (name) => {
  return name.replace('automations/discovery-bot/contacts/', '');
}

const getFormInfos = (settings) => {
  const stateFormInfos = reduce(formNames, (items, formName) => {
    items[formName] = {
      query: null,
      ready: false,
    };
    if (isContactForm(formName)) {
      const type = contactFormType(formName);
      const q = find(settings.contact_conditions, { type });
      if (q) {
        items[formName].query = q.query;
      }
    }
    return items;
  }, {});
  stateFormInfos['automations/discovery-bot'].query = settings.search_query || {};
  // stateFormInfos['automations/discovery-bot/window'].query = settings.open_window_search_query || {};
  return stateFormInfos;
}

function ResultRenderer(props) {
  const { data } = props;
  if (!data) {
    return null;
  }
  if (data.$error) {
    return (
      <span className="text-danger"><Fa name="exclamation-triangle" /> {data.$error}</span>
    );
  }
  let errorCount = 0;
  let successCount = 0;
  each(data.$submittedResults, (result) => {
    if (result.success) {
      successCount += 1;
    } else {
      errorCount += 1;
    }
  });
  const comps = [];
  if (successCount > 0) {
    comps.push((
      <span key="success" className="text-success"><NumberDisplay value={successCount} suffix="success" suffixIsUnit precision={0} /></span>
    ));
  }
  if (successCount > 0 && errorCount > 0) {
    comps.push((
      <span key="space">{' | '}</span>
    ));
  }
  if (errorCount > 0) {
    comps.push((
      <span key="error" className="text-danger"><NumberDisplay value={errorCount} suffix="error" suffixIsUnit precision={0} /></span>
    ));
  }

  return (<span>{comps}</span>);
}

ResultRenderer.propTypes = {
  data: PropTypes.shape({
    $error: PropTypes.string,
    $submittedResults: PropTypes.arrayOf(PropTypes.shape({})),
  }),
}

class FeedbackHistoryRunPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      loading: false,
      loaded: false,
      /*
      searchQuery: null,
      contactQuery: null,
      formReady: false,
      contactFormReady: false,
      */

      formInfos: reduce(formNames, (items, formName) => {
        items[formName] = {
          query: null,
          ready: false,
        };
        return items;
      }, {}),
      
      selectedTab: 'searchForm',
      formUpdate: 0,
      sticky: false,
      currentSelectedRange: null,
      currentDateControlType: DateRangeField.MODE_CUSTOM_RANGES,
      currentSelectedRangeError: null,
      disabled: false,
      mode: MODE_SEARCH,
      searching: false,
      collector: props.validCollectors.length ? props.validCollectors[0] : null,
      allOpportunities: [],
      allAccounts: [],
      opportunities: [],
      accounts: [],
      showingResult: null,
      showingResultModal: false,
      currentCount: null,
      showConfirm: false,
      allAutomations: [],
      dateRangeLabel: null,
      currentSelectedAutomation: null,
      startDate: null,
      endDate: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleCloneQuery = this.handleCloneQuery.bind(this);
    this.checkDirty = this.checkDirty.bind(this);
    this.handleProgress = this.handleProgress.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.getRowClass = this.getRowClass.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
    this.closeResultModal = this.closeResultModal.bind(this);
    this.showConfirm = this.showConfirm.bind(this);
    this.resultValueGetter = this.resultValueGetter.bind(this);
    this.handleSelectAutomation = this.handleSelectAutomation.bind(this);
    this.onDateUpdate = this.onDateUpdate.bind(this);
    this.handleSearchReady = this.handleSearchReady.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.automationType !== this.props.automationType && nextProps.automationType !== 'manual') {
      this.setState({ selectedTab: 'searchForm' });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.destroyStickyFooter();
  }

  onDateUpdate(path, d) {
    let dateRangeLabel = null;
    if (d.start || d.end) {
      const format = 'YYYY-MM-DD';
      const displayFormat = 'MMM DD, YYYY';

      const s = d.start ? moment(d.start, format) : null;
      const e = d.end ? moment(d.end, format) : null;
      if (s && s.isValid() && e && e.isValid()) {
        const startDate = s.format(displayFormat);
        const endDate = e.format(displayFormat);
        if (startDate !== endDate) {
          dateRangeLabel = `from ${startDate} to ${endDate}`;
        } else {
          dateRangeLabel = `on ${startDate}`;
        }
      } else if (s && s.isValid()) {
        const startDate = s.format(displayFormat);
        dateRangeLabel = `after ${startDate}`;
      } else if (e && e.isValid()) {
        const endDate = e.format(displayFormat);
        dateRangeLabel = `before ${endDate}`;
      }

    }
    this.setState({
      currentDateControlType: d.control_type,
      currentSelectedRange: d.values,
      // dateLabels: d.labels,
      startDate: d.start,
      endDate: d.end,
      dateRangeLabel,
      ...((!d.values || (d.values[0] === null && d.values[1] === null)) ? {
        currentCount: null,
        currentSelectedRangeError: 'Please select a date range',
      } : { currentSelectedRangeError: null }),
    });
  }

  getSearchCount() {
    if (this.props.closeDateFilter) {
      const params = {
        type: 'groupAND',
        values: [
          {
            _id: this.props.closeDateFilter._id,
            type: 'include',
            filter_id: this.props.closeDateFilter._id,
            values: this.state.currentSelectedRange,
          },
        ],
      };
      this.props.dispatch(countOpportunities({ is_closed: true, query: params }))
        .then(
          ({ total }) => {
            this.setState({ currentCount: total });
          },
          () => {
            this.setState({ currentCount: null });
          },
        );
    }
  }

  handleSelectAutomation(automation) {
    this.setState({
      loading: true,
      loaded: false,
    }, () => {
      let start = moment().subtract(29, 'days').startOf('day').format('YYYY-MM-DD');
      let end = moment().endOf('day').format('YYYY-MM-DD');

      if (automation.sync_lookback_period && automation.sync_lookback_unit) {
        start = moment().subtract(automation.sync_lookback_period, automation.sync_lookback_unit).startOf('day').format('YYYY-MM-DD');
        end = moment().endOf('day').format('YYYY-MM-DD');
      }
      
      this.props.initialize({
        ...automation,
        [automation.source === 'account' ? 'account_sender_conditions' : 'opportunity_sender_conditions']: automation.sender_conditions || [],
      });

      const formInfos = getFormInfos(automation);

      this.setState({
        loading: false,
        loaded: true,
        currentSelectedRange: [start, end],
        startDate: start,
        endDate: end,
        currentDateControlType: DateRangeField.MODE_CUSTOM_RANGES,
        currentCount: null,
        currentSelectedRangeError: null,
        formInfos,
        currentSelectedAutomation: automation,
      }, () => {
        this.initStickyFooter();
      });
    });
  }

  showConfirm() {
    this.setState({ showConfirm: true });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  checkDirty() {
    each(formNames, (formName) => {
      this.props.dispatch(checkDirty(formName), isContactForm(formName));
    });
  }

  handleTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  handleSearchReady(type) {
    const newState = { ...this.state.formInfos, [type]: {
      query: this.state.formInfos[type]?.query || {},
      ready: true,
    } };
    this.setState({ formInfos: newState }, () => {
      this.checkDirty(); 
    });
  }

  handleCloneQuery(searchQuery) {
    this.setState({ searchQuery, formUpdate: this.state.formUpdate + 1 }, () => {
      this.checkDirty();
    });
  }

  resultValueGetter(params) {
    const { data } = params;
    if (!data) {
      return null;
    }

    
    if (data.$error) {
      return `Error: ${data.$error}`;
    }
  
    let errorCount = 0;
    let successCount = 0;
    each(data.$submittedResults, (result) => {
      if (result.success) {
        successCount += 1;
      } else {
        errorCount += 1;
      }
    });
    const comps = [];
    if (successCount > 0) {
      comps.push(pluralize('success', successCount));
    }
    if (errorCount > 0) {
      comps.push(pluralize('error', errorCount));
    }
  
    return comps.join(' | ');
  }

  handleDone() {
    // notify run finish
    const { automationSource } = this.props;
    const isAccount = automationSource === 'account';
    const total = isAccount ? this.state.allAccounts?.length : this.state.allOpportunities?.length;

    const el = (
      <div>Finished submitting contacts for <NumberDisplay value={total} suffix={isAccount ? 'account' : 'opportunity'} suffixIsUnit precision={0} /></div>
    );
    this.context.addNotification(el, { autoClose: false });
  }

  handleCellClick({ data }) {
    if (data) {
      this.setState({ showingResult: data, showingResultModal: true });
    }
  }

  handleProgress(event) {
    const {
      done,
      success,
      opportunityId,
      accountId,
      submittedResults, totalSubmitted, hasSucceed,
      error,
    } = event;
    const { automationSource } = this.props;
    
    const isAccount = automationSource === 'account';
    const resourceId = isAccount ? accountId : opportunityId;

    if (!done) {
      const allResources = isAccount ? this.state.allAccounts : this.state.allOpportunities;

      const newResrouce = find(allResources, { [isAccount ? 'account_id' : 'opportunity_id']: resourceId });
      if (newResrouce) {
        newResrouce.$success = success;
        newResrouce.$hasSucceed = hasSucceed;
        newResrouce.$error = error;
        if (success) {
          newResrouce.requested_feedbacks = totalSubmitted;
          newResrouce.$submittedResults = values(submittedResults);
        }
        const newResrouces = [...(isAccount? this.state.accounts : this.state.opportunities), newResrouce];
        this.setState({ [isAccount ? 'accounts' : 'opportunities']: newResrouces }, () => {
          if (this.gridApi) {
            const node = this.gridApi.getRowNode(resourceId);
            if (node) {
              this.gridApi.flashCells({ rowNodes: [node] });
            }
          }
        });
        /*
        if (!this.gridApi) {
          const newResrouces = [...(isAccount? this.state.accounts : this.state.opportunities), newResrouce];
          this.setState({ [isAccount ? 'accounts' : 'opportunities']: newResrouces });
        } else {
          this.gridApi.updateRowData({ add: [newResrouce] });
          const node = this.gridApi.getRowNode(resourceId);
          if (node) {
            this.gridApi.flashCells({ rowNodes: [node] });
          }
        }
        */
      }
    }
  }

  getRowClass(params) {
    const { node: { data } } = params;
    if (data) {
      if (data.$success === false || data.$hasSucceed === false) {
        return styles.rowError;
      }
      if (data.$success === true) {
        return styles.rowSuccess;
      }
    }
    return null;
  }

  getExtraColumns() {
    return [
      {
        colId: 'result',
        headerName: 'Submitted Results',
        width: 140,
        hide: false,
        pinned: 'right',
        suppressMiniFilter: true,
        suppressSorting: true,
        suppressMenu: true,
        suppressMovable: true,
        suppressToolPanel: true,
        cellRenderer: ResultRenderer,
        valueGetter: this.resultValueGetter,
        onCellClicked: this.handleCellClick,
        cellStyle: () => ({ cursor: 'pointer' }),
        cellRendererParams: {
          column: {
            label: 'Submitted Results',
          },
        },
      },
    ];
  }

  formattedResults(searchResults) {
    const indexedOwners = searchResults.owners || {};
    const indexedAccounts = searchResults.accounts || {};
    each(searchResults.opportunities, (opportunity) => {
      opportunity.owner = indexedOwners[opportunity.owner_id];
      opportunity.account = indexedAccounts[opportunity.account_id];
      const closeDate = opportunity.close_date ? moment(opportunity.close_date, 'YYYY-MM-DD') : null;
      const createdDate = opportunity.created_date ? moment(opportunity.created_date, 'YYYY-MM-DD') : null;
      opportunity.close_date = closeDate;
      opportunity.created_date = createdDate;
    });
    
    searchResults.formattedAccounts = reduce(searchResults.accounts, (items, account) => {
      account.owner = indexedOwners[account.owner_id];
      items.push(account);
      return items;
    }, []);

    return searchResults;
  }

  closeResultModal() {
    this.setState({ showingResultModal: false });
  }

  handleSubmit(params) {
    const { startDate, endDate, formInfos } = this.state;
    const { automationSource } = this.props;
    const propFormInfos = this.props.formInfos;

    const isAccount = automationSource === 'account';

    params.full_automation_lookback_period = Number.parseInt(params.full_automation_lookback_period, 10);
    
    if (formInfos['automations/discovery-bot']?.ready) {
      params.search_query = cleanSubmitCriteria(propFormInfos['automations/discovery-bot']?.query);
    }

    const contactConditions = [];

    each(formNames, (formName) => {
      if (isContactForm(formName) && formInfos[formName]?.ready) {
        contactConditions.push({
          type: contactFormType(formName),
          query: cleanSubmitCriteria(propFormInfos[formName]?.query),
        })
      }
    });
    params.contact_conditions = contactConditions;


    const newSettings = {
      ...params,
      start_date: null,
      end_date: null,
      // collector_id: currentSelectedAutomation ? currentSelectedAutomation.tv_collector_id : null,
    };
    if (startDate[0]) {
      newSettings.start_date = startDate;
    }
    if (endDate) {
      newSettings.end_date = endDate;
    }

    delete newSettings.all_contact_roles;
    delete newSettings.all_contact_reference_fields;
    delete newSettings.api_key;
    delete newSettings.enabled;
    delete newSettings.automation_type;
    delete newSettings.auto_open_request_window;
    delete newSettings.open_window_search_query;
    delete newSettings.open_window_owner_must_be_enabled;
    delete newSettings.sync;
    delete newSettings.bot_version;
    delete newSettings.bot_version_last_used;
    delete newSettings.bypass_invitation;
    delete newSettings.$isManual;


    newSettings.sender_conditions = isAccount ? params.account_sender_conditions : params.opportunity_sender_conditions;
    delete newSettings.account_sender_conditions;
    delete newSettings.opportunity_sender_conditions;

    newSettings.sender_conditions = reduce(cloneDeep(newSettings.sender_conditions), (items, sc, order) => {
      items.push({
        order: order + 1,
        query: sc.query,
        field: sc.field,
      });
      return items;
    }, []);
    this.gridApi = null;
    this.gridColumnApi = null;
    this.setState({
      searching: true, id: null, total: 0, allOpportunities: [], allAccounts: [], opportunities: [], accounts: [],
      showingResultModal: false, showingResult: null,
    }, () => {
      this.props.dispatch(feedbackHistoryRun(newSettings))
        .then(
          (results) => {
            const { total, opportunities, id } = results;
            const returnResults = opportunities.length;
            if (total) {
              const formattedOpportunities = this.formattedResults(results);
              this.setState({
                searching: false, mode: MODE_RESULTS, id, total, 
                allOpportunities: formattedOpportunities.opportunities,
                allAccounts: formattedOpportunities.formattedAccounts,
                // accounts: formattedOpportunities.formattedAccounts, // set on process
              });
            } else {
              this.setState({ searching: false });
            }
            let el = null;
            if (!total) {
              el = (
                <div>
                  Your search return no results.
                </div>
              );
            } else if (total && returnResults < total) {
              el = (
                <div>
                  Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                  For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
                </div>
              );
            }
            if (el) {
              this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
            }
          },
          (e) => {
            if (e && e.data && e.data.message) {
              const el = (
                <div>{e.data.message}</div>
              );
              this.context.addNotification(el, { type: 'error' });
            }
            this.setState({ searching: false });
          },
        );
    });
  }

  initStickyFooter() {
    if (this.footerRef && this.sentinalRef) {
      this.observer = new window.IntersectionObserver((records) => {
        if (!records[0].isIntersecting) {
          this.setState({ sticky: true });
        } else {
          this.setState({ sticky: false });
        }
      });
      this.observer.observe(this.sentinalRef);
    }
  }

  destroyStickyFooter() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  fetchData() {
    this.setState({ loading: true, loaded: false });

    const p1 = this.props.dispatch(fetchFeedbackRequestAutomation('opportunities', 'NEW'));
    const p2 = this.props.dispatch(fetchAllFeedbackRequestAutomations());
    Promise.all([p1, p2])
      .then(
        ([manualSettings, { settings }]) => {
          if (this.mounted) {
            
            // https://github.com/lumen-software/TruSales/issues/1674
            manualSettings.name = 'Manual';
            manualSettings.$isManual = true;

            const validCollector = find(this.props.validCollectors, { is_active: true }) || first(this.props.validCollectors);
            if (validCollector) {
              manualSettings.tv_collector_id = validCollector.collector_id;
            }

            // https://github.com/lumen-software/TruSales/issues/1478
            // https://github.com/lumen-software/TruSales/issues/1674
            /*
            let newSettings = {
              full_automation_contact_types: ['opportunity_contacts'],
              owner_must_be_enabled: !settings.bypass_invitation,
            };
          
            const defaultAutomation = find(settings, { is_sytem: true }) || first(settings);
            if (defaultAutomation) {
              newSettings = {
                ...defaultAutomation,
                ...newSettings,
              };
            } 
            */
            this.setState({ allAutomations: [...settings, manualSettings] }, () => {
              this.handleSelectAutomation(manualSettings);
            });
          }
        },
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: false, searchQuery: null });
          }
        },
      );
  }

  renderField({
    input, label, type, meta: { touched, error }, componentClass, placeholder, options,
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    const { disabled } = this.state;
    return (
      <FormGroup validationState={validationState}>
        {label !== null && label !== undefined && label.length > 0 && <ControlLabel>{label}</ControlLabel>}
        {componentClass !== 'select' && <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={(submitting || disabled)} />}
        {componentClass === 'select' &&
          <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={(submitting || disabled)}>
            {options !== null && options !== undefined && options.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
          </FormControl>
        }
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderSearchForm(type, description = null) {
    const {
      submitting, ownerMustBeEnabled,
      bypassInvitation, opportunityStatus,
      automationSource, opportunityFromExternalOwner,
    } = this.props;
    const {
      formUpdate, disabled,
      currentCount, currentSelectedRangeError,
      currentSelectedAutomation, formInfos,
    } = this.state;

    let query = formInfos[type]?.query || {};

    let shouldRenderOwnerField = false;
    let shouldRenderDateRangeField = false;
    let shouldRenderStatusField = false;
    let customFooterControls = null;
    const ownerEnabled = ownerMustBeEnabled;
    const isAccount = automationSource === 'account';

    if (type === 'automations/discovery-bot') {
      shouldRenderOwnerField = true;
      shouldRenderDateRangeField = true;
      shouldRenderStatusField = true;
    }


    if (keys(query).length === 0) {
      query = {};
    }

    const innerFields = [];

    if (shouldRenderOwnerField) {
      innerFields.push(
        (
          <div key="one">
            <OpportunityOwnerField
              value={bypassInvitation ? ownerEnabled : true}
              path={[]}
              level={1}
              showDelete={false}
              isAccount={isAccount}
              showInclude={false}
              disabled={(submitting || disabled)}
              editable={bypassInvitation}
              searchCriteria={{
                _id: 'owner-enabled',
                type: 'include',
                filter: {
                  _id: 'owner-enabled-filter',
                  label: isAccount ? 'Account/Company Owner': 'Opportunity/Deal Owner',
                },
              }}
              onChange={(value) => {
                this.props.change('owner_must_be_enabled', bypassInvitation ? value : true);
              }}
              onUpdate={() => {}}
              searchType={type}
            />
          </div>
        )
      );
      innerFields.push((<div key="two">&nbsp;</div>));
    }


    if (isAccount) {
      innerFields.push(
        (
          <div key="three">
            <AccountOwnerField
              value={opportunityFromExternalOwner}
              path={['opportunity_owner']}
              level={1}
              showDelete={false}
              showInclude={false}
              disabled={submitting}
              searchCriteria={{
                _id: 'opportunity-owner',
                type: 'include',
                filter: {
                  _id: 'opportunity-owner',
                  label: 'Opportunity/Deal owner',
                },
              }}
              onChange={(v) => {
                this.props.change('full_automation_opportunity_from_external_owner', v);
              }}
              searchType={type}
              onUpdate={() => {}}
              
            />
          </div>
        )
      );
      innerFields.push((<div key="three-1">&nbsp;</div>));
    }

    if (shouldRenderDateRangeField) {      
      innerFields.push((
        <div key="four">
          <DateRangeField
            path={[]}
            key={currentSelectedAutomation ? currentSelectedAutomation._id: 'manual'}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={(submitting || disabled)}
            renderDescription
            searchCriteria={{
              _id: 'main-close-date',
              type: 'include',
              filter: {
                _id: 'main-close-date',
                label: 'Date Range',
                description: 'TruSales will run the full automation algorithm on opportunities with close dates that fall within this range setup',
              },
              values: this.state.currentSelectedRange,
              control_type: this.state.currentDateControlType,
            }}
            onUpdate={this.onDateUpdate}
            searchType={type}
          >
            {currentSelectedRangeError === null && currentCount !== null &&
              <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                {currentCount > 1 &&
                  <HelpBlock>
                    <Fa name="info-circle" />
                    {' '}
                    <strong>
                      <Counter value={currentCount}>
                        <NumberDisplay value={currentCount} suffix="opportunity" suffixIsUnit precision={0} />
                      </Counter>
                    </strong>
                    {' '}
                    have close dates within this range.
                  </HelpBlock>
                }
                {currentCount === 1 &&
                  <HelpBlock><Fa name="info-circle" /> One opportunity has close dates within this range.</HelpBlock>
                }
                {currentCount === 0 &&
                  <HelpBlock><Fa name="info-circle" /> No opportunities have close dates within this range.</HelpBlock>
                }
              </div>
            }
            {currentSelectedRangeError !== null &&
              <div className="text-danger">
                <Fa name="exclamation-triangle" /> {currentSelectedRangeError}
              </div>
            }
          </DateRangeField>
        </div>
      ));
    }
    
    if (!isAccount && shouldRenderStatusField) {
      innerFields.push((<div key="five">&nbsp;</div>));
      innerFields.push((
        <div key="six" className="animated fadeIn">
          <OpportunityStatusField
            value={opportunityStatus}
            path={['opportunity_status']}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting}
            searchCriteria={{
              _id: 'opportunity-status',
              type: 'include',
              filter: {
                _id: 'opportunity-status',
                label: 'Opportunity Status',
              },
            }}
            onChange={this.props.change}
            searchType={type}
            onUpdate={() => {}}
          />
        </div>
      ));  
    }
    
    return (
      <div>
        {description !== null && <div className="well well-sm"><Fa name="info-circle" /> {description}</div>}

        <SearchForm
          key={`form-${formUpdate}`}
          dropup
          onSearchChange={() => {
            this.handleSearchReady(type);
          }}
          showRootLogicalORWarning
          disabled={(submitting || disabled)}
          standalone
          simpleMode
          defaultCriteria={query}
          type={type}
        >
          {innerFields.length > 0 ? innerFields : null}
        </SearchForm>
      </div>
    );
  }

  renderAutomationSelector() {
    const { allAutomations, currentSelectedAutomation } = this.state;
    
    const menus = [];
    each(allAutomations, (allAutomation) => {
      if (allAutomation.$isManual) {
        menus.push((<MenuItem divider />));
      }
      menus.push((
        <MenuItem
          key={allAutomation._id}
          eventKey={allAutomation}
          active={(currentSelectedAutomation && currentSelectedAutomation._id === allAutomation._id)}
          onSelect={this.handleSelectAutomation}
        >
          {allAutomation.name} {allAutomation.is_system ? <Fa name="star" className="text-warning" /> : null}
        </MenuItem>
      ));
    });

    return (
      <div>
        <ControlLabel>Use Settings For:</ControlLabel>
        {' '}
        <span>
          <Dropdown
            id="automation-selector"
          >
            <Dropdown.Toggle bsSize="small">
              <span>
                {(currentSelectedAutomation ? currentSelectedAutomation.name : 'Select an automation')}
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {menus}
            </Dropdown.Menu>
          </Dropdown>
        </span>
      </div>
    );
  }

  renderContent() {
    const {
      handleSubmit, submitting, valid,
      footerHeight,
      validCollectors,
      tvCollectorId,
      automationSource,
      accountSenderConditions,
      opportunitySenderConditions,
      resellers,
    } = this.props;
    
    const {
      selectedTab, currentSelectedRangeError,
      disabled, searching, currentSelectedAutomation,
    } = this.state;
    
    const isAccount = automationSource === 'account';

    /*
    const isReady = reduce(formNames, (items, formName) => {
      return items && this.state.formInfos[formName]?.ready;
    }, true);
    */
    const isReady = true;
    
    const allCollectors = reduce(validCollectors, (items, item) => {
      items.push({
        value: item.collector_id,
        label: item.is_active ? item.collector_name : `${item.collector_name} (inactive)`,
      });
      return items;
    }, [{
      value: null,
      label: 'Select TruVoice survey collector',
    }]);

    const validCollector = currentSelectedAutomation ? find(validCollectors, { collector_id: tvCollectorId }) : null;
    const hasValidCollectors = validCollector !== null && validCollector !== undefined;

    let msg = (
      <span>
        Please assign a TruVoice Survey Collector to enable automation: <Link to="/setup/feedback-requests/automations">Setup Survey Collector <Fa name="arrow-right" /></Link>
      </span>
    );

    if (currentSelectedAutomation && currentSelectedAutomation._id) {
      msg = (
        <span>
          Please assign a TruVoice Survey Collector to enable automation: <Link to={`/setup/feedback-requests/automations`}>Setup Survey Collector <Fa name="arrow-right" /></Link>
        </span>
      );
    }

    const isValidCollector = validCollector && validCollector.is_active;

    const sourceTypes = [
      { value: 'opportunity', label: 'Opportunities/Deals', description: 'Automation checks Opportunities/Deals'},
      { value: 'account', label: 'Accounts/Companies', description: 'Automation checks Accounts/Companies'},
    ];

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className={`panel panel-default ${styles.panel}`}>
          <div className="panel-heading">
            Run Full Automation on Past {isAccount ? 'Accounts' : 'Opportunities'}
          </div>
          
          
          <div className={`panel-body ${styles.panelBody} ${(this.state.sticky ? styles.sticky : '')}`}>

          
            <div className="well well-sm">
              <p>
                Perform a history run to check past opportunities and automatically submit qualified opportunities for feedback based on the conditions set below.
              </p>
              <p>
                First, set the Date Range, or lookback period for the history run. Only opportunities with close dates within the selected period will be evaluated in the history run.
              </p>
              <p>
                Next, set the trigger conditions opportunities must meet to be qualified for feedback.
              </p>
              <p>
                Next, set the contact submit conditions, or the conditions TruSales will use to select which account and opportunity contacts will be submitted for opportunities that qualify.
              </p>
              <p>
                Finally, click the &ldquo;Run&rdquo; button to have TruSales perform the history run and automatically submit contacts for opportunities that qualify.
              </p>
            </div>

            <FormGroup>
              <div className="clearfix">
                <div className="pull-left">
                  {this.renderAutomationSelector()}
                </div>

                <div className="pull-right">
                  <TruVoiceDomainAuthorization />
                </div>
              </div>

              <p>&nbsp;</p>

              <Field
                label="Automation Source"
                name="source"
                componentClass="select"
                options={sourceTypes}
                component={this.renderField}
              />

              <p>&nbsp;</p>

              {validCollectors.length !== 1 && 
                <Field
                  label="Survey Collector"
                  name="tv_collector_id"
                  componentClass="select"
                  options={allCollectors}
                  component={this.renderField}
                />
              }

              {!hasValidCollectors &&
                <HelpBlock>
                  <span className="text-danger"><Fa name="exclamation-triangle" /> {msg}</span>
                </HelpBlock>
              }

              {!isValidCollector && validCollector !== null && validCollector !== undefined &&
                <HelpBlock>
                  <span className="text-danger"> Collector <strong>{validCollector.collector_name}</strong> is inactive</span>
                </HelpBlock>
              }
              <p>&nbsp;</p>
            </FormGroup>
              


              <Tabs
                activeKey={(selectedTab || 'searchForm')}
                onSelect={this.handleTabSelect}
                id="discovery-bot-form-tabs"
                animation={false}
              >
                <Tab
                  eventKey="searchForm"
                  title="Trigger Conditions"
                >
                  <div style={{ padding: 15, border: '1px solid #eee' }}>
                    {this.renderSearchForm('automations/discovery-bot', `Only ${isAccount ? 'accounts/companies' : 'opportunities/deals'} that match the filter(s) below will be eligible for feedback requests:`)}
                  </div>
                </Tab>
                <Tab
                  eventKey="sender"
                  title="Sender Settings"
                >
                  <div style={{ padding: 15, border: '1px solid #eee' }}>
                    <SenderList
                      senderConditions={isAccount ? accountSenderConditions : opportunitySenderConditions}
                      key={isAccount ? 'account-base' : 'opportunity-base'}
                      isAccount={isAccount}
                      onChange={(v) => {
                        this.props.change(isAccount ? 'account_sender_conditions' : 'opportunity_sender_conditions', v);
                      }}
                    />
                  </div>
                </Tab>

                <Tab
                  eventKey="resellers"
                  title="Email Recipients"
                >
                  <div style={{ padding: 15, border: '1px solid #eee' }}>
                    <ResellerList
                      resellers={resellers}
                      isAccount={isAccount}
                      onChange={(v) => {
                        this.props.change('resellers', v);
                      }}
                      disabled={submitting}
                    />
                  </div>
                </Tab>

                <Tab
                  eventKey="contactForm"
                  title="Contact Submit Conditions"
                >
                  <div style={{ padding: 15, border: '1px solid #eee' }}>
                    <ContactTriggerOptions
                      allRoles={currentSelectedAutomation.all_contact_roles}
                      activityTypes={this.props.activityTypes}
                      contactTypes={this.props.contactTypes}
                      contactRoles={this.props.contactRoles}
                      contactReferenceFields={this.props.contactReferenceFields}
                      opportunityContactTypes={this.props.opportunityContactTypes}
                      primaryContactsOnly={this.props.primaryContactsOnly}
                      dateRange={this.state.currentSelectedRange}
                      contactFromExternalAccount={this.props.contactFromExternalAccount}
                      fullAutomationSingleOpportunity={this.props.fullAutomationSingleOpportunity}
                      gongRequireOpportunityOwner={this.props.gongRequireOpportunityOwner}
                      requestShowSyncTab={() => { this.handleTabSelect('searchForm'); }}
                      disabled={submitting}
                      submitting={submitting}
                      onChange={this.props.change}
                      isAccount={isAccount}
                      dateRangeLabel={this.state.dateRangeLabel}
                      onSearchReady={this.handleSearchReady}
                      formInfos={this.state.formInfos}
                    />
                  </div>
                </Tab>
              </Tabs>

          </div>
          <div
            ref={(el) => { this.footerRef = el; }}
            className={`panel-footer ${styles.panelFooter} ${(this.state.sticky ? styles.sticky : '')}`}
            style={{ bottom: `${footerHeight}px` }}
          >
            <div className="clearfix">
              <div className="pull-right text-right">
                {!searching &&
                  <Button onClick={this.showConfirm} bsStyle="primary" disabled={disabled || !isReady || !valid || submitting || !hasValidCollectors || !isValidCollector || currentSelectedRangeError !== null} type="button">
                    {!submitting && <span>Run</span>}
                    {submitting && <span><Fa name="spinner" spin /> Running</span>}
                  </Button>
                }
                {searching && <Button disabled bsStyle="primary"><Fa name="spinner" spin /> Running</Button>}
              </div>
            </div>
          </div>
          <div ref={(el) => { this.sentinalRef = el; }} />
        </div>
        <div style={{ height: '150px' }} />
        <Modal show={this.state.showConfirm} onHide={() => { this.setState({ showConfirm: false }); }}>
          <Modal.Header closeButton>
            <h4 className="text-danger"><Fa name="exclamation-triangle" /> Execute History Run Now?</h4>
          </Modal.Header>
          <Modal.Body>
            <p className="text-danger">Are you sure you want to have TruSales automatically submit {isAccount ? 'accounts' : 'opportunities'} and contacts based on the current trigger and submit conditions? This action can&rsquo;t be undone.</p>
          </Modal.Body>
          <Modal.Footer className="clearfix">
            <Button onClick={() => { this.setState({ showConfirm: false }); }} bsStyle="default" className="pull-left">Cancel</Button>
            <Button onClick={() => { this.props.handleSubmit(this.handleSubmit)(); this.setState({ showConfirm: false }); }} bsStyle="primary" className="pull-right">Yes, Submit Now</Button>
          </Modal.Footer>
        </Modal>
      </form>
    );
  }

  renderResultModal() {
    const { showingResult, showingResultModal } = this.state;
    if (!this.state.showingResult) {
      return null;
    }
    let title = 'Submit Results';
    if (showingResult) {
      title = `Submit Results for ${showingResult.name}`;
    }
    const hasError = showingResult.$error !== null &&  showingResult.$error !== undefined;
    return (
      <Modal key="modal" show={showingResultModal} onHide={this.closeResultModal}>
        <Modal.Header closeButton>
          <h4>{title}</h4>
        </Modal.Header>
        <Modal.Body>
          {hasError &&
            <div className="alert alert-danger">{showingResult.$error}</div>
          }
          {!hasError &&
            <div>
              <ul>
                {(showingResult.$submittedResults || []).map((result) => {
                  const success = result.success === true;
                  let errorMessage = null;
                  if (!success && result.errors && result.errors.message) {
                    errorMessage = result.errors.message;
                  }
                  const isDuplicated = errorMessage === 'Duplicated contact.';
                  if (isDuplicated) {
                    errorMessage = 'Duplicated contact. This person has been asked to provide feedback for a past opportunity and campaign is set to not allow additional submissions';
                  }
                  return (
                    <li key={result.contact.contact_id}>
                      <Fa className={success ? 'text-success' : 'text-danger'} name={success ? 'check-circle' : 'exclamation-triangle'} />
                      {' '}
                      {result.contact.name}
                      {!success && errorMessage !== null && <span className="text-danger"> ({errorMessage})</span>}
                    </li>
                  );
                })}
              </ul>
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.closeResultModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderResults() {
    const { id, opportunities, accounts } = this.state;
    const { automationSource } = this.props;
    
    const isAccount = automationSource === 'account';

    return (
      <div>
        <div className="well">
          <HistoryRunProgress
            key={id}
            total={isAccount ? this.state.allAccounts?.length : this.state.allOpportunities?.length}
            searchId={id}
            isAccount={isAccount}
            onConfirm={() => { this.setState({ mode: MODE_SEARCH }); }}
            onProgress={this.handleProgress}
            onDone={this.handleDone}
          />
        </div>

        {!isAccount &&
          <OpportunityTable
            key={id}
            opportunities={opportunities}
            tableName="hisotry-run-table"
            onGridReady={this.onGridReady}
            getRowClass={this.getRowClass}
            columns={this.getExtraColumns()}
          />
        }

        {isAccount && accounts.length > 0 &&
          <AccountTable
            key={id}
            accounts={accounts}
            columns={this.getExtraColumns()}
            isManager={false}
            tableName="hisotry-run-account-table"
          />
        }

        {this.renderResultModal()}
        <RequestFeedbackManager />
      </div>
    );
  }

  render() {
    const { loading, loaded, mode } = this.state;
    const isLoading = loading || !loaded;
    return (
      <div>
        <Helmet title="Feedback Request History Run | Organization Setup" />
        {isLoading && <ProgressBar />}
        {!isLoading &&
          <div>
            {mode === MODE_SEARCH && this.renderContent()}
            {mode === MODE_RESULTS && this.renderResults()}
          </div>
        }
      </div>
    );
  }
}

const selector = formValueSelector('discoveryBotsSettings'); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps(state) {
  const organization = getUserCurrentOrganization(state);
  const settings = getDiscoveryBotSettings(state);
  const enabled = selector(state, 'enabled');
  const automationType = selector(state, 'automation_type');
  const activityTypes = selector(state, 'full_automation_activity_types');
  const contactTypes = selector(state, 'full_automation_contact_types');
  const contactRoles = selector(state, 'full_automation_contact_roles');
  const contactReferenceFields = selector(state, 'full_automation_contact_reference_fields');
  const autoOpenRequestWindow = selector(state, 'auto_open_request_window') === 'true' || selector(state, 'auto_open_request_window') === true;

  return {
    organization,
    settings,
    enabled,
    automationType,
    activityTypes,
    contactRoles,
    contactReferenceFields,
    contactTypes,
    
    formInfos: reduce(formNames, (items, formName) => {
      items[formName] = {
        query: getSearchQuery(formName, state),
        isDirty: getIsDirty(formName, state),
      };
      return items;
    }, {}),

    autoOpenRequestWindow,
    sync: selector(state, 'sync'),
    footerHeight: getFooterHeight(state),
    ownerMustBeEnabled: selector(state, 'owner_must_be_enabled'),
    openWindowOwnerMustBeEnabled: selector(state, 'open_window_owner_must_be_enabled'),
    gongRequireOpportunityOwner: selector(state, 'gong_require_opportunity_owner'),
    bypassInvitation: selector(state, 'bypass_invitation'),
    opportunityContactTypes: selector(state, 'full_automation_opportunty_contact_types'),
    tvCollectorId: selector(state, 'tv_collector_id'),
    formValues: getFormValues('discoveryBotsSettings')(state),
    closeDateFilter: getCloseDateFilter(state),
    opportunityStatus: selector(state, 'opportunity_status'),
    automationSource: selector(state, 'source'),
    fullAutomationSingleOpportunity: selector(state, 'full_automation_single_opportunity'),
    accountSenderConditions: selector(state, 'account_sender_conditions'),
    opportunitySenderConditions: selector(state, 'opportunity_sender_conditions'),
    contactFromExternalAccount: selector(state, 'full_automation_contact_from_external_account'),
    opportunityFromExternalOwner: selector(state, 'full_automation_opportunity_from_external_owner'),
    resellers: selector(state, 'resellers'),
  };
}

FeedbackHistoryRunPage.propTypes = {
  location: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  dirty: PropTypes.bool,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  change: PropTypes.func,
  valid: PropTypes.bool,
  settings: PropTypes.shape({
    all_contact_roles: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  enabled: PropTypes.bool,
  automationType: PropTypes.string,
  activityTypes: PropTypes.arrayOf(PropTypes.string),
  contactRoles: PropTypes.arrayOf(PropTypes.string),
  contactReferenceFields: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  contactTypes: PropTypes.arrayOf(PropTypes.string),
  autoOpenRequestWindow: PropTypes.bool,
  sync: PropTypes.bool,
  footerHeight: PropTypes.number,
  ownerMustBeEnabled: PropTypes.bool,
  gongRequireOpportunityOwner: PropTypes.bool,
  openWindowOwnerMustBeEnabled: PropTypes.bool,
  bypassInvitation: PropTypes.bool,
  validCollectors: PropTypes.arrayOf(PropTypes.shape({})),
  formValues: PropTypes.shape({}),
  tvCollectorId: PropTypes.string,
  closeDateFilter: PropTypes.shape({
    _id: PropTypes.string,
  }),
  opportunityContactTypes: PropTypes.string,
  opportunityStatus: PropTypes.arrayOf(PropTypes.string),
  automationSource: PropTypes.string,
  fullAutomationSingleOpportunity: PropTypes.bool,
  accountSenderConditions: PropTypes.arrayOf(PropTypes.shape({})),
  opportunitySenderConditions: PropTypes.arrayOf(PropTypes.shape({})),
  contactFromExternalAccount: PropTypes.bool,
  opportunityFromExternalOwner: PropTypes.bool,
  formInfos: PropTypes.shape(reduce(formNames, (items, formName) => {
    items[formName] = PropTypes.shape({
      query:  PropTypes.shape({}),
      isDirty:  PropTypes.bool,
    });
    return items;
  }, {})),
  resellers: PropTypes.arrayOf(PropTypes.shape({})),
};
FeedbackHistoryRunPage.defaultProps = {
  settings: null,
  submitting: false,
  dirty: false,
  handleSubmit: () => {},
  initialize: () => {},
  reset: () => {},
  change: () => {},
  error: null,
  enabled: false,
  valid: false,
  activityTypes: [],
  contactRoles: [],
  contactTypes: [],
  automationType: 'manual',
  autoOpenRequestWindow: false,
  sync: false,
  footerHeight: 0,
  ownerMustBeEnabled: false,
  openWindowOwnerMustBeEnabled: false,
  bypassInvitation: false,
  validCollectors: [],
  formValues: {},
  closeDateFilter: null,
  opportunityContactTypes: 'roles-and-primary',
  tvCollectorId: null,
  opportunityStatus: ['closed'],
  automationSource: 'opportunity',
  fullAutomationSingleOpportunity: false,
  accountSenderConditions: [],
  opportunitySenderConditions: [],
  contactFromExternalAccount: false,
  opportunityFromExternalOwner: false,
  resellers: [],
};
FeedbackHistoryRunPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};


const validate = (data) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   full_automation_activity_threshold: {
  //     presence: true,
  //     numericality: { greaterThanOrEqualTo: 0, strict: true, onlyInteger: true },
  //   },
  //   opportunity_status: {
  //     presence: {
  //       allowEmpty: false,
  //       message: '^Please select at least one "Opportunity Status"',
  //     },
  //     type: {
  //       type: (value) => {
  //         return isArray(value);
  //       },
  //     },
  //   },
  // };

  const schema = Joi.object({
    full_automation_activity_threshold: Joi.number().integer().min(0).required().messages({
      'number.base': 'Activity threshold must be a number',
      'number.integer': 'Activity threshold must be an integer',
      'number.min': 'Activity threshold must be at least 0',
      'any.required': 'Activity threshold is required',
    }),
    opportunity_status: Joi.array().min(1).required().messages({
      'array.base': 'Opportunity status must be an array',
      'array.min': 'Please select at least one "Opportunity Status"',
      'any.required': 'Opportunity status is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const FeedbackHistoryRunForm = reduxForm({
  form: 'discoveryBotsSettings',
  validate,
})(FeedbackHistoryRunPage);

export default connect(mapStateToProps)(FeedbackHistoryRunForm);
